export default __webpack_public_path__ + "static/media/High-end-all-in-one-dual-screen.07fc97b6.png";